import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
// import TimePicker from 'react-time-picker';
// import DatePicker, { DateObject } from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import DatePicker, { DateObject } from "react-multi-date-picker";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const AddShiftTimeModal = ({ show, onClose, onCreated, refresh }) => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [service_sttm, setServiceSTTMValue] = useState(new DateObject({ hour: 6, minute: 0, meridiem: 'AM' }));
    const [serviceStartTime, setServiceStartTime] = useState(new DateObject({ hour: 6, minute: 0, meridiem: 'AM' }));
    const [serviceEndTime, setServiceEndTime] = useState(new DateObject({ hour: 15, minute: 0, meridiem: 'PM' }));

    const [shifttimeName, setShifttimeName] = useState('');
    const [description, setDescription] = useState('');
    const [shiftStartTime, setShiftStartTime] = useState(''); // time in HH:mm:ss
    const [shiftEndTime, setShiftEndTime] = useState(''); // time in HH:mm:ss
    const [errors, setErrors] = useState({});
    const [nameLengthError, setNameLengthError] = useState('');
    const [descLengthError, setDescLengthError] = useState('');

    const handleShifttimeNameChange = (e) => {
        let value = e.target.value;
        value = value.charAt(0).toUpperCase() + value.slice(1);
        setShifttimeName(value);

        if (value.length <= 300) {
            setNameLengthError('');
        }
    };

    const handleDescriptionChange = (e) => {
        let value = e.target.value;
        value = value.charAt(0).toUpperCase() + value.slice(1);
        setDescription(value);

        if (value.length > 500) {
            setDescLengthError('Limit reached (max 500 characters)');
        } else {
            setDescLengthError('');
        }
    };

    // const formatTime = (time) => {
    //     // Ensure the time is formatted as HH:mm:ss (with leading zeros if necessary)
    //     const [hours, minutes, seconds] = time.split(':');
    //     return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    // };

    const formatToHHmmss = (dateObject) => {
        const hours = String(dateObject.hour).padStart(2, '0');
        const minutes = String(dateObject.minute).padStart(2, '0');
        const seconds = '00'; // Assuming seconds are always 00
        return `${hours}:${minutes}:${seconds}`;
    };

    // const handleSubmit = () => {
    //     // Clear previous errors
    //     setErrors({});
    //     setNameLengthError('');
    //     setDescLengthError('');

    //     // Validation for shift time name
    //     if (!shifttimeName) {
    //         setErrors((prev) => ({
    //             ...prev,
    //             shifttime_name: 'This field is required',
    //         }));
    //         return;
    //     }

    //     // Validation for length of shift time name
    //     if (shifttimeName.length > 300) {
    //         setNameLengthError('Limit reached (max 300 characters)');
    //         return;
    //     }

    //     // Validation for description length
    //     if (description.length > 500) {
    //         setDescLengthError('Limit reached (max 500 characters)');
    //         return;
    //     }

    //     // Validation for shift start and end times
    //     if (!shiftStartTime || !shiftEndTime) {
    //         setErrors((prev) => ({
    //             ...prev,
    //             shift_times: 'Both shift start and end times are required',
    //         }));
    //         return;
    //     }

    //     // Format times to ensure they match HH:mm:ss
    //     const formattedStartTime = formatTime(shiftStartTime);
    //     const formattedEndTime = formatTime(shiftEndTime);

    //     // Proceed with API call if validation passes
    //     axios
    //         .post('http://192.168.3.105:1711/api/shifttime', {
    //             shifttime_name: shifttimeName,
    //             description: description,
    //             shift_start_time: formattedStartTime,
    //             shift_end_time: formattedEndTime,
    //         })
    //         .then(() => {
    //             onClose();
    //             if (onCreated) onCreated(); // Refresh list after add
    //         })
    //         .catch((error) => {
    //             if (error.response?.status === 400) {
    //                 // Handle validation error for already existing shift time
    //                 if (error.response.data?.message === 'Shift Time name already exists.') {
    //                     setErrors((prev) => ({
    //                         ...prev,
    //                         shifttime_name: 'Shift Time with this name already exists',
    //                     }));
    //                 } else if (error.response.data.errors) {
    //                     // Handle other validation errors
    //                     setErrors(error.response.data.errors);
    //                 }
    //             } else {
    //                 console.error('Create failed:', error);
    //             }
    //         });
    // };


    const [data_name, setData] = useState([]);

    useEffect(() => {
        axios.get(`${baseURL}/shifttime/list`)
            .then(response => {
                setData(response.data.data.data.map(mode => mode.shifttime_name.toLowerCase()));
            })
            .catch(error => {
            console.log('There was an error fetching the data!', error);
            });
    }, []);

    const handleSubmit = () => {
        setErrors({});
        setNameLengthError('');
        setDescLengthError('');
    
        if (!shifttimeName) {
            setErrors((prev) => ({ ...prev, shifttime_name: 'This field is required' }));
            return;
        } else if (data_name.includes(shifttimeName.trim().toLowerCase())) {
            setErrors((prev) => ({ ...prev, shifttime_name: 'This Name Already Exists' }));
            return;
        }
    
        if (shifttimeName.length > 300) {
            setNameLengthError('Limit reached (max 300 characters)');
            return;
        }
    
        if (description.length > 500) {
            setDescLengthError('Limit reached (max 500 characters)');
            return;
        }
    
        if (!serviceStartTime || !serviceEndTime) {
            setErrors((prev) => ({ ...prev, shift_times: 'Both shift start and end times are required' }));
            return;
        }
    
        const formattedStart = formatToHHmmss(serviceStartTime);
        const formattedEnd = formatToHHmmss(serviceEndTime);
    
        axios
            .post(`${baseURL}/shifttime`, {
                shifttime_name: shifttimeName,
                description: description,
                shift_start_time: formattedStart,
                shift_end_time: formattedEnd,
            })
            .then(() => {
                refresh();
                onClose();
                if (onCreated) onCreated();
                toast.success("Shift Time Created successfully!"); 
            })
            .catch((error) => {
                if (error.response?.status === 400) {
                    if (error.response.data?.message === 'Shift Time name already exists.') {
                        setErrors((prev) => ({ ...prev, shifttime_name: 'Shift Time with this name already exists' }));
                    } else if (error.response.data.errors) {
                        setErrors(error.response.data.errors);
                    }
                } else {
                    console.error('Create failed:', error);

                }
            });
    };

    
    return (
        <Modal show={show} size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Create Shift Time</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className='text-white'>×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Shift Name<span className="required">*</span></label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Shift Name"
                                value={shifttimeName}
                                onChange={handleShifttimeNameChange}
                            />
                            {errors.shifttime_name && <div className="text-danger">{errors.shifttime_name}</div>}
                            {nameLengthError && <div className="text-danger">{nameLengthError}</div>}
                        </div>

                      

                        {/* <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Start Time<span className="required">*</span></label>
                            <div className='datepicker-wrapper d-flex'>
                                <div className='input-group-text bg-transparent border-0 px-0'>
                                    <i className='fa-solid fa-clock fs-4'></i>
                                </div>
                                <DatePicker
                                    disableDayPicker
                                    // value={shiftStartTime}
                                    value={service_sttm}
                                    // onChange={setShiftStartTime}
                                    onChange={setServiceSTTMValue}
                                    // format="HH:mm:ss"
                                    format="hh : mm A"
                                    placeholder='Select Start Time'
                                    plugins={[
                                        <TimePicker />
                                    ]}
                                />
                            </div>
                        </div>
 

                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">End Time<span className="required">*</span></label>
                            <div className='datepicker-wrapper d-flex'>
                                <div className='input-group-text bg-transparent border-0 px-0'>
                                    <i className='fa-solid fa-clock fs-4'></i>
                                </div>
                                <DatePicker
                                    disableDayPicker
                                    // value={shiftEndTime}
                                    // onChange={setShiftEndTime}
                                    value={service_sttm}
                                    onChange={setServiceSTTMValue}
                                    format="hh : mm A"
                                    plugins={[
                                        <TimePicker />
                                    ]}
                                />
                            </div>
                        </div> */}

                        {/* Start Time Picker */}
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Start Time<span className="required">*</span></label>
                            <div className='datepicker-wrapper d-flex'>
                                <div className='input-group-text bg-transparent border-0 px-0'>
                                    <i className='fa-solid fa-clock fs-4'></i>
                                </div>
                                <DatePicker
                                    disableDayPicker
                                    value={serviceStartTime}
                                    onChange={setServiceStartTime}
                                    format="hh : mm A"
                                    placeholder='Select Start Time'
                                    plugins={[<TimePicker />]}
                                />
                            </div>
                        </div>

                        {/* End Time Picker */}
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">End Time<span className="required">*</span></label>
                            <div className='datepicker-wrapper d-flex'>
                                <div className='input-group-text bg-transparent border-0 px-0'>
                                    <i className='fa-solid fa-clock fs-4'></i>
                                </div>
                                <DatePicker
                                    disableDayPicker
                                    value={serviceEndTime}
                                    onChange={setServiceEndTime}
                                    format="hh : mm A"
                                    placeholder='Select End Time'
                                    plugins={[<TimePicker />]}
                                />
                            </div>
                        </div>


                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Description</label>
                            <textarea
                                rows={8}
                                className="form-control"
                                placeholder="Description"
                                value={description}
                                onChange={handleDescriptionChange}
                            />
                            {descLengthError && <div className="text-danger">{descLengthError}</div>}
                        </div>
                    </div>

                    {/* <div className="d-flex align-items-center justify-content-center gap-3 mt-4 mb-4">
                        <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link>
                        <Link type="button" className="btn btn-sm btn-primary" onClick={handleSubmit}>Create Shift Time</Link>
                    </div> */}
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        <button type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>Create Shift Time
                        <i className="fas fa-angle-double-right ms-2"></i>
                        </button>
                    </div>
            
                </div>
            </div>
        </Modal>
    );
};

export default AddShiftTimeModal;
